import { FormEvent, useEffect, useState } from 'react';
import { useGetAuftragMessagesMutation, useWriteAuftragMessageMutation } from '../../../api/AuftragAPI';
import { useWhoamiMutation } from '../../../api/LoginAPI';
import { IAuftragMessage, ProfileInfo } from '../../../types/Types';
import { formatToEuroDateTime } from '../../../util/DateUtils';
import MaxInputAnzahlComponent from '../../MaxInputAnzahlComponent';


interface ThisProps {
  //callback1?: (location: ILocation) => void; // Callback-Prop
  //statusChanged: () => void;
  //changeColor: (auftraguid: string, color: string) => void;
  //centerOnMap: (id: string) => void;
  auftragUid: string,
}

/**
 * @author noone
 */
const AuftragMessageComponent: React.FC<ThisProps> = ({ auftragUid }) => {

  const [getMessages] = useGetAuftragMessagesMutation();
  const [writeMessage] = useWriteAuftragMessageMutation();
  const [whoamiAPI] = useWhoamiMutation();

  const [messages, setMessages] = useState<IAuftragMessage[]>([]);
  const [profileInfo, setProfileInfo] = useState<ProfileInfo>();

  const [messageText, setMessageText] = useState<string>("");

  const sendMessage = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    /*const form = e.target as HTMLFormElement;
    const input = form.elements.namedItem("messageText") as HTMLInputElement;
    const messageText = input?.value ?? "";
*/
    // leere das Input-Feld
    //if (input) input.value = "";

    writeMessage({ uid: auftragUid, dto: { text: messageText } }).unwrap()
      .then(() => {
        setMessageText("");
        getMessages(auftragUid).unwrap().then((data) => {
          setMessages(data);
        }).catch((error) => console.log(error));
      })
      .catch((error) => console.log(error));
  }

  useEffect(() => {
    document.getElementById('newMessageForm')?.scrollIntoView({behavior: "smooth"});
  }, [messages]);

  useEffect(() => {
    whoamiAPI().unwrap()
      .then(setProfileInfo)
      .catch((error) => console.log(error));

    getMessages(auftragUid).unwrap()
      .then((data) => setMessages(data))
      .catch((error) => console.log(error));

  }, []);

  return (
    <>

      <h3>Chat Liste</h3>

      <div>

        {messages?.map((e, index) => (
          <div key={index} style={{ display: 'flex', justifyContent: e.erstelltVonEmail === profileInfo?.email ? 'flex-end' : 'flex-start', marginBottom: '10px' }}>
            <div style={{
              backgroundColor: e.erstelltVonEmail === profileInfo?.email ? '#dcf8c6' : '#f1f0f0',
              borderRadius: '10px',
              padding: '10px',
              maxWidth: '70%',
              wordWrap: 'break-word',
            }}> 
              <div style={{ minWidth: '200px' }}>
                <div style={{ textAlign: 'left', marginBottom: '5px' }}>
                  <span style={{ fontSize: "8pt" }}>{e.erstelltVonEmail}</span>
                </div>
                {e.text}
                <div style={{ textAlign: 'right' }}>
                  <span style={{ fontSize: "8pt" }}>{formatToEuroDateTime(e.erstelltAm)}</span>
                </div>
              </div>
            </div>
          </div>
        ))}

        <p>
          Neue Nachricht:
          <form id='newMessageForm' onSubmit={sendMessage}>
            <input type="text" name="messageText" className='form-control' required={true} placeholder='Neue Nachricht...' value={messageText} onChange={(e) => setMessageText(e.target.value)} maxLength={255} />
            <MaxInputAnzahlComponent max={255} aktuell={messageText.length} />
            <button type="submit" className='btn btn-primary' style={{ marginTop: "10px" }}>Senden</button>
          </form>
        </p>

      </div>
    </>
  );

}

export default AuftragMessageComponent;